import axios from "axios";

export const axiosIntance=axios.create({
    baseURL:'https://ecommerce99.pythonanywhere.com'
})